<div class="panel" role="dialog" [attr.aria-label]="dialogLabel()" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  @if (showsCalendar()) {
    <seiri-date-calendar
      [selected]="calendarSelected()"
      [min]="min()"
      [max]="max()"
      [startAt]="startAt()"
      [startView]="startView()"
      (selectedChange)="pickDay($event)"
    />
  }
  @if (showsTime()) {
    @if (showsCalendar()) {
      <hr class="divider" />
    }
    <seiri-time-stepper [(value)]="draft" />
    <button mat-flat-button type="button" class="confirm" [disabled]="!canConfirm()" (click)="confirm()">
      Potvrdiť
    </button>
  }
</div>
